import { assign } from "lodash";

export const startNewGame = () => dispatch =>
  new Promise(resolve => {
    dispatch({ type: "START_NEW_GAME" });
    resolve();
  }).then(() => {
    emitter.emit("startNewGameComplete");
  });

export const toggleEdges = () => dispatch =>
  new Promise(resolve => {
    dispatch({ type: "TOGGLE_EDGES" });
    resolve();
  }).then(() => {
    emitter.emit("toggleEdgesComplete");
  });

export const togglePreview = () => dispatch =>
  new Promise(resolve => {
    dispatch({ type: "TOGGLE_PREVIEW" });
    resolve();
  }).then(() => {
    emitter.emit("togglePreviewComplete");
  });

export const startAnimation = () => dispatch =>
  new Promise(resolve => {
    dispatch({ type: "START_ANIMATION" });
    resolve();
  }).then(() => {
    emitter.emit("startAnimationComplete");
  });

export const endAnimation = () => dispatch =>
  new Promise(resolve => {
    dispatch({ type: "END_ANIMATION" });
    resolve();
  }).then(() => {
    emitter.emit("endAnimationComplete");
  });

export const subtractFromTime = params => dispatch =>
  new Promise(resolve => {
    dispatch(assign(params, { type: "SUBTRACT_FROM_TIME" }));
    resolve();
  }).then(() => {
    emitter.emit("subtractFromTimeComplete");
  });


// WEBPACK FOOTER //
// ./src/actions/index.js